<template>
  <b-collapse class="evaluation-card" animation="slide" :open="isOpen" data-cy="gops-data">
    <template #trigger="{ open }">
      <header class="card-header" role="button" :aria-expanded="open.toString()">
        <p class="card-header-title">
          Oferta de crédito
        </p>
        <a class="card-header-icon">
          <b-icon :icon="open ? 'minus' : 'plus'" />
        </a>
      </header>
    </template>
    <section class="card-block p-0 pb-1">
      <div class="subcard">
        <b-field label="Monto total crédito" horizontal class="has-addons">
          <div class="field has-addons">
            <p class="control">
              <a class="button is-static">UF</a>
            </p>
            <b-input
              v-model="simulation.offerResponse.creditAmount"
              :disabled="readOnly"
              size="is-small"
              type="number"
              placeholder="Ingresa valor en UF"
              expanded />
          </div>
        </b-field>

        <b-field label="Monto financiamiento" horizontal class="has-addons">
          <div class="field has-addons">
            <p class="control">
              <a class="button is-static">UF</a>
            </p>
            <b-input
              v-model="simulation.offerResponse.financingAmount"
              :disabled="readOnly"
              size="is-small"
              type="number"
              placeholder="Ingresa valor en UF"
              expanded />
          </div>
        </b-field>

        <b-field label="Monto líquido requerido" horizontal class="has-addons">
          <div class="field has-addons">
            <p class="control">
              <a class="button is-static">UF</a>
            </p>
            <b-input
              v-model="simulation.offerResponse.amountRequestedByClient"
              :disabled="readOnly"
              size="is-small"
              type="number"
              placeholder="Ingresa valor en UF"
              expanded />
          </div>
        </b-field>

        <b-field label="Monto bruto requerido" horizontal class="has-addons">
          <div class="field has-addons">
            <p class="control">
              <a class="button is-static">UF</a>
            </p>
            <b-input
              v-model="simulation.offerResponse.credituAmount"
              :disabled="readOnly"
              size="is-small"
              type="number"
              placeholder="Ingresa valor en UF"
              expanded />
          </div>
        </b-field>
      </div>

      <div class="subcard is-gray">
        <b-field label="¿Monto máx. a prestar?" horizontal class="has-addons">
          <div class="field has-addons">
            <p class="control">
              <a class="button is-static">UF</a>
            </p>
            <b-input
              v-model="simulation.offerResponse.approvedAmount"
              :disabled="readOnly"
              class="pr-2"
              size="is-small"
              type="number"
              placeholder="Ingresa valor de la propiedad"
              expanded />
            <b-button
              class="header-icon"
              size="is-small"
              data-cy="propertiesMaximumAmount"
              :icon-left="propertiesMaximumAmount ? 'angle-down' : 'angle-right'"
              @click="togglePropertiesMaximumAmount" />
          </div>
        </b-field>
        <div v-if="propertiesMaximumAmount" class="fields-has-text-right">
          <b-field label="Máx. por carga financiera" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">UF</a>
              </p>
              <b-input
                v-model="simulation.offerResponse.approvedAmountFinanceCharge"
                :disabled="readOnly"
                size="is-small"
                type="number"
                placeholder="Ingresa el valor"
                expanded />
            </div>
          </b-field>

          <b-field label="Máx. por dividiendo-renta" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">UF</a>
              </p>
              <b-input
                v-model="simulation.offerResponse.approvedAmountIncomeDividend"
                :disabled="readOnly"
                size="is-small"
                type="number"
                placeholder="Ingresa el valor"
                expanded />
            </div>
          </b-field>

          <b-field label="Máx. por deuda garantía" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">UF</a>
              </p>
              <b-input
                v-model="simulation.offerResponse.approvedAmountLoanToValue"
                :disabled="readOnly"
                size="is-small"
                type="number"
                placeholder="Ingresa el valor"
                expanded />
            </div>
          </b-field>
        </div>
      </div>

      <dividend-sub-card :simulation="simulation" :show-content="showDividend" :read-only="readOnly" />
      <maximum-quota-sub-card :simulation="simulation" :show-content="showMaximumQuota" :read-only="readOnly" />

      <div class="subcard is-gray">
        <div class="subcard-header">
          <p class="header-title">Ratios financieros</p>
          <b-button
            class="header-icon"
            size="is-small"
            :icon-left="propertiesFinancialRatios ? 'angle-up' : 'angle-down'"
            @click="togglePropertiesFinancialRatios" />
        </div>

        <div v-if="propertiesFinancialRatios" class="subcard-content fields-has-text-right">
          <b-field label="Carga financiera" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">%</a>
              </p>
              <b-input
                :disabled="readOnly"
                size="is-small"
                placeholder="Ingresa valor"
                :value="formatPercentage(simulation.offerResponse.backEndRatio)"
                expanded />
            </div>
          </b-field>

          <b-field label="Dividendo-renta" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">%</a>
              </p>
              <b-input
                :disabled="readOnly"
                size="is-small"
                placeholder="Ingresa valor"
                :value="formatPercentage(simulation.offerResponse.frontEndRatio)"
                expanded />
            </div>
          </b-field>

          <b-field label="Deuda-garantía" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">%</a>
              </p>
              <b-input
                :disabled="readOnly"
                size="is-small"
                placeholder="Ingresa valor"
                :value="formatPercentage(simulation.offerParams.maximumCreditLTV)"
                expanded />
            </div>
          </b-field>

          <b-field label="Pie" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">%</a>
              </p>
              <b-input
                :disabled="readOnly"
                size="is-small"
                placeholder="Ingresa valor"
                :value="formatPercentage(simulation.offerResponse.loanToValueHome)"
                expanded />
            </div>
          </b-field>

          <b-field label="Cobertura" horizontal class="has-addons">
            <div class="field has-addons">
              <p class="control">
                <a class="button is-static">%</a>
              </p>
              <b-input
                :disabled="readOnly"
                size="is-small"
                placeholder="Ingresa valor"
                :value="formatPercentage(simulation.offerResponse.financingRatio)"
                expanded />
            </div>
          </b-field>
        </div>
      </div>
    </section>
  </b-collapse>
</template>

<script>
import { mapState } from 'vuex';
import DividendSubCard
  from '@/ui/components/internal/evaluations/verify/DividendSubCard.vue';
import MaximumQuotaSubCard
  from '@/ui/components/internal/evaluations/verify/MaximumQuotaSubCard.vue';
import { formatPercentage } from '@/infrastructure/format';

export default {
  name: 'CreditOfferCard',
  components: { MaximumQuotaSubCard, DividendSubCard },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      propertiesMaximumAmount: true,
      showDividend: true,
      showMaximumQuota: true,
      propertiesFinancialRatios: true
    };
  },
  computed: {
    ...mapState('evaluation', ['simulation'])
  },
  methods: {
    formatPercentage,
    togglePropertiesMaximumAmount() {
      this.propertiesMaximumAmount = !this.propertiesMaximumAmount;
    },
    togglePropertiesFinancialRatios() {
      this.propertiesFinancialRatios = !this.propertiesFinancialRatios;
    }
  }
};
</script>

<style scoped>

.collapse-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
}

</style>
